import { makeAutoObservable } from "mobx";
import UserService from "../services/UserService";
import OfferService from "../services/OfferService";

export default class PageStore {
    user = {};
    offers = [];
    currentPrompt = '';
    limitArray = [10, 20, 30, 40];
    offersPages = 0;
    offersPage = 1;
    offersLimit = 10;
    isAuth = false;
    isLoading = false;
    isError = '';

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    setUser(user) {
        this.user = user;
    }

    setOffers(offers) {
        this.offers = offers;
    }

    setCurrentPrompt(currentPrompt) {
        this.currentPrompt = currentPrompt;
    }

    toggleSelectedOffers(id) {
        const offer = this.offers.find((o) => o._id === id);

        if (offer) offer.selected = !offer.selected;
    }

    selectAllOffers(selected) {
        this.offers.forEach((o) => (o.selected = selected));
    }

    setOffersPages(pages) {
        this.offersPages = pages;
    }

    setOffersPage(page) {
        this.offersPage = page;
    }

    setOffersLimit(limit) {
        this.offersLimit = limit;
    }

    setAuth(bool) {
        this.isAuth = bool;
    }

    setIsLoading(bool) {
        this.isLoading = bool;
    }

    setIsError(error) {
        this.isError = error;
    }

    authFunctionWrapper(callback) {
        return async (...args) => {
            this.setIsLoading(true);
            try {
                return await callback(...args);
            } catch (error) {
                const errorMsg = error?.response?.data?.message || error?.message;
                if (errorMsg === 'TOKEN_EXPIRED') {
                    console.log('refresh');
                    try {
                        await this.checkIsAuth();
                    } catch (err) {
                        this.setIsError(err);
                    }
                } else {
                    this.setIsError(errorMsg);
                }
            } finally {
                this.setIsLoading(false);
            }
        }
    }

    async login(username, password) {
        this.setIsLoading(true);
        try {
            const { data } = await UserService.login(username, password);
            localStorage.setItem('token', data.token);
            this.setUser(data.user);
            this.setAuth(true);

        } catch (error) {
            this.setIsError(error?.response?.data?.message || error?.message)
        } finally {
            this.setIsLoading(false);
        }
    }

    async authWithTg(username, tgId) {
        this.setIsLoading(true);
        try {
            const { data } = await UserService.login(username, null, tgId);
            localStorage.setItem('token', data.token);
            this.setUser(data.user);
            this.setAuth(true);
        } catch (error) {

            this.setIsError(error?.response?.data?.message || error?.message)
        } finally {
            this.setIsLoading(false);
        }
    }

    async logout() {
        this.setIsLoading(true);
        try {
            await UserService.logout();
            localStorage.removeItem('token');
            this.setUser({});
            this.setAuth(false);
        } catch (error) {
            this.setIsError(error?.response?.data?.message || error?.message)
        } finally {
            this.setIsLoading(false);
        }
    }

    async checkIsAuth() {
        this.setIsLoading(true);
        try {
            const { data } = await UserService.refresh();
            localStorage.setItem('token', data.token);
            this.setUser(data.user);
            this.setAuth(true);
        } catch (error) {
            this.setIsError(error?.response?.data?.message || error?.message)
            this.setAuth(false);
        } finally {
            this.setIsLoading(false);
        }
    }

    getAllOffer = this.authFunctionWrapper(async (params = {}) => {
        const { data } = await OfferService.getAll({ ...params, limit: this.offersLimit, page: this.offersPage });
        this.setOffers(data.offers.map(offer => ({ ...offer, selected: false })));
        this.setOffersPages(data.pages);
        this.setOffersPage(data.page)
        this.setOffersPage(
            (data.pages < data.page) ?
                (data.pages || 1) : data.page
        );
    })

    generateNewOffers = this.authFunctionWrapper(async (text, thread) => {
        const { data } = await OfferService.generate({ text, threadId: thread });
        return data;
    })

    getCurrentPrompt = this.authFunctionWrapper(async () => {
        const { data } = await OfferService.getPrompt();
        this.setCurrentPrompt(data.promptData);
        return data;
    })

    updateCurrentPrompt = this.authFunctionWrapper(async (newPrompt) => {
        const { data } = await OfferService.updatePrompt(newPrompt);
        return data;
    })

    addNewOffers = this.authFunctionWrapper(async (offers, thread) => {
        const { data } = await OfferService.save(offers, thread);
        return data;
    })

    updateOffer = this.authFunctionWrapper(async (id, offer) => {
        const { data } = await OfferService.update(id, offer);
        return data;
    })

    deleteOffers = this.authFunctionWrapper(async (offersId) => {
        const { data } = await OfferService.delete(offersId);
        return data;
    })
}